import React from "react";
import {
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import VSNTypography from "../../../shared/VSNTypography";
import VSNButton from "../../../shared/VSNButton";
import { toggleModelShow } from "../../../shared/CustomFunc";

export const useStyles = makeStyles((theme) => ({
  title: {
    "&.MuiTypography-root": {
      fontWeight: 700,
      lineHeight: "31.25px",
      fontSize: "24px",
      padding: "20px 0",
      whiteSpace: "nowrap",
      marginRight: 32,
      textOverflow: "ellipsis",
      overflow: "hidden",
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
        lineHeight: "26px",
        whiteSpace: "unset",
        "-webkit-line-clamp": "2",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        padding: 0,
        margin: "20px 32px 20px 0",
      },
    },
  },
  modalHeader: {
    position: "sticky",
    top: 0,
    background: "var(--white)",
    zIndex: 3,
  },
  button_groups: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "#F6F6FD",
    padding: "20px 25px",
    gap: 10,
    marginLeft: "-25px",
    marginRight: "-25px",
    position: "sticky",
    bottom: 0,
    zIndex: 99,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: "15px",
      gap: 10,
      marginLeft: "-15px",
      marginRight: "-15px",
    },
  },
  button: {
    "&.MuiButtonBase-root": {
      color: "var(--white)",
      padding: "13px 25px",
      minWidth: "150px",
      borderRadius: 10,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      "& span.icon": {
        marginLeft: 8,
        display: "inline-block",
      },
      "& .content": {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      "& .loader": {
        "& .MuiCircularProgress-root": {
          height: "16px !important",
          width: "16px !important",
        },
      },
      "&.link": {
        background: "var(--white)",
        border: "1px solid var(--Tertiary)",
        color: "var(--Tertiary)",
        "& .linkIcon": {
          height: "16px",
          width: "16px",
          display: "inline-block",
          marginRight: 10,
        },
      },
    },
  },
}));

const ViewUserDocumentListModal = ({
  dispatch,
  documentReportList,
  documentReportListLoader,
  documentDownloaded,
  handleDocumentDownload,
}) => {
  const classes = useStyles();

  return (
    <Box style={{ position: "relative" }}>
      <Box className={classes.modalHeader}>
        <VSNTypography
          id="modal-modal-title-1"
          variant="h4"
          component="h2"
          className={classes.title}
        >
          Documents List
        </VSNTypography>
        <Divider
          sx={{
            borderColor: "#EAEDF0",
            marginLeft: { sm: "-25px", xs: "-15px" },
            marginRight: { sm: "-25px", xs: "-15px" },
          }}
        />
      </Box>

      {!documentReportListLoader ? (
        <TableContainer className={classes.documentTable}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Document Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Uploaded by</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Size</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {documentReportListLoader ? (
                <TableRow>
                  <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                    <CircularProgress size={24} color="inherit" />
                  </TableCell>
                </TableRow>
              ) : documentReportList?.length > 0 ? (
                documentReportList.map((doc, index) => (
                  <TableRow key={index}>
                    <TableCell>{doc?.name}</TableCell>
                    <TableCell>
                      <VSNTypography>{doc?.uploaded_by}</VSNTypography>
                    </TableCell>
                    <TableCell>
                      <VSNTypography>{doc?.size}</VSNTypography>
                    </TableCell>
                    <TableCell>
                      <VSNTypography>{doc?.uploaded_at}</VSNTypography>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" gap={2}>
                        <IconButton
                          sx={{ borderRadius: 1.5, backgroundColor: "#F2FBF5" }}
                          onClick={() =>
                            handleDocumentDownload(doc?.url, doc?.id)
                          }
                        >
                          {documentDownloaded[doc?.id] ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            <DownloadOutlinedIcon
                              style={{ color: "#34A259" }}
                            />
                          )}
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={5}
                    sx={{ textAlign: "center", color: "gray" }}
                  >
                    No Document Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Stack direction="row" justifyContent="center" py={5}>
          <CircularProgress size={24} color="inherit" />
        </Stack>
      )}

      <Box className={classes.button_groups}>
        <VSNButton
          className={`${classes.button} `}
          handleClick={() => {
            dispatch(toggleModelShow("ViewUploadUserDocumnetList"));
          }}
        >
          Cancel
        </VSNButton>
      </Box>
    </Box>
  );
};

export default ViewUserDocumentListModal;
